module.exports = __webpack_public_path__ + "static/media/postural-training.1ca6b114.jpg";